
import VueApp from '@/@types/app/VueApp';
import { HOME, LOGIN } from '@/routerNames';
import { Component, Prop } from 'vue-property-decorator';
import AdminCompanies from '@/components/pages/admin/AdminCompanies/AdminCompanies.vue';
import AdminDashboard from '@/components/pages/admin/AdminDashboard/AdminDashboard.vue';
import AdminJobs from '@/components/pages/admin/AdminJobs/AdminJobs.vue';
import AdminCompany from '@/components/pages/admin/AdminCompany/AdminCompany.vue';

type Page = 'dashboard' | 'companies' | 'jobs' | 'company';

@Component({
  components: { AdminCompany, AdminCompanies, AdminDashboard, AdminJobs },
})
export default class AdminPanel extends VueApp {
  @Prop({ type: String, default: 'dashboard' }) page: Page;
  @Prop({ type: String, default: null }) id: string;

  navigate(page: Page) {
    this.$router.push({ name: this.$route.name, params: { page } });
  }

  mounted() {
    const user = this.$store.state.user;

    // Preserve the deep link via `?redirect=` so superadmins clicking an
    // external link (e.g. the subscription-change email "Review in admin
    // panel" button) land back on the intended company page after sign-in.
    // Mirrors AuthMiddleware.ts and the LoginForm completion flow which
    // both consume `route.query.redirect`.
    if (!user) {
      this.$router.push({ name: LOGIN, query: { redirect: this.$route.fullPath } });
      return;
    }

    if (!user.isSuperAdmin()) {
      this.$router.push({ name: HOME });
    }
  }
}
